import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { HeaderGlobal, Breadcrumb } from 'src/components';
import { useSelector, useDispatch } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import { ILEmptyOrganisasi } from 'src/assets/image';
import Pagination from 'react-js-pagination';
import { setDataFileDatasets, setFormSearchDatas } from 'src/config/redux/action/';
import { Helmet } from "react-helmet";

const File = ({ ...props }) => {
    const { formSearchDatas } = useSelector(state => state.dataReducer);
    const { dataFiles, totResultFiles } = useSelector(state => state.fileReducer);
    const dispatch = useDispatch();
    const [sortBy, setSortBy] = useState();
    const [activePage, setCurrentPage] = useState(1);

    const {
        OrganisasiText
    } = formSearchDatas;
    const opdsPerPage = 10;

    useEffect(() => {
        dispatch(setDataFileDatasets(1, sortBy, OrganisasiText))
        window.scrollTo({ top: 0, behavior: "smooth" })
    }, [dispatch])

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber)
        dispatch(setDataFileDatasets(pageNumber, sortBy, OrganisasiText));
        window.scrollTo({ top: 0, behavior: "smooth" })
    };

    const handleSort = (by) => {
        setSortBy(by)
        setCurrentPage(1)
        dispatch(setDataFileDatasets(1, by, OrganisasiText));
    }

    const btnPencarian = () => {
        setCurrentPage(1)
        dispatch(setDataFileDatasets(opdsPerPage, 1, OrganisasiText));
    }

    const handleKeyDownSearch = (event) => {
        if (event.key === 'Enter') {
            setCurrentPage(1)
            dispatch(setDataFileDatasets(opdsPerPage, 1, OrganisasiText));
        }
    }


    return (
        <>
            <Helmet>
                <meta charSet='utf-8' />
                <title>{`File | Portal Satu Data Kabupaten Sigi`}</title>
                <meta name='description' content={`File | Portal Satu Data Kabupaten Sigi`} />
            </Helmet>
            <div className="site-main">
                <HeaderGlobal />
                <section className="ttm-row aboutus-section ttm-bgcolor-grey clearfix">
                    <div className="container-xl mt-4 res-767-mt-0">

                        {/* BREADCUMB */}
                        <Breadcrumb crumbs={props.crumbs} />
                        {/* BREADCUMB */}

                        <section className="sidebar ttm-sidebar ttm-bgcolor-grey clearfix">
                            <div className="container-xl">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="section-title with-desc text-center clearfix">
                                            <div className="title-header mt-5">
                                                <h2 className="title">Telusuri Berdasarkan  <span>Jenis File</span></h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row no-gutters">
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-lg-12 mb-3 mt-3">
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        className="form-control pl-3"
                                                        style={{ background: 'white', borderColor: '#0170C1' }}
                                                        placeholder="Cari Dataset..."
                                                        value={OrganisasiText}
                                                        onChange={(e) => dispatch(setFormSearchDatas('OrganisasiText', e.target.value))}
                                                        onKeyDown={handleKeyDownSearch} 
                                                    />
                                                    <div className="input-group-append">
                                                        <button className="btn ttm-bgcolor-skincolor" type="button" onClick={btnPencarian}>
                                                            <i className="fa fa-search mr-1" /> Pencarian!
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                {
                                                    dataFiles &&
                                                    <p className="products-result-count">Showing {dataFiles.length == 0 ? 0 : 1}–{dataFiles.length} of {(totResultFiles)} results</p>
                                                }
                                            </div>

                                            <div className="col-md-6">
                                                <form className="products-ordering float-sm-right" method="get">
                                                    <div className="form-group mb-30">
                                                        <select name="orderby" className="form-control border" onChange={(e) => handleSort(e.target.value)}>
                                                            <option value="">Sortir Berdasarkan</option>
                                                            <option value="1">Sort (Nama Opd) ASC - DESC</option>
                                                            <option value="2">Sort (Nama Opd) DESC - ASC</option>
                                                            <option value="3">Sort (Tgl. Opd) ASC - DESC</option>
                                                            <option value="4">Sort (Tgl. Opd) DESC - ASC</option>
                                                        </select>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        dataFiles ?
                                            dataFiles.length != 0 ?
                                                <>
                                                    {
                                                        dataFiles.map((v, i) => {
                                                            return (
                                                                <div key={i} className="col-md-6 col-lg-3">
                                                                    <div className="featured-icon-box style6">
                                                                        <div className="featured-content text-center">
                                                                            <center>
                                                                                <div className="ttm-icon ttm-icon_element-border ttm-textcolor-skincolor ttm-icon_element-size-md">
                                                                                    <i className="flaticon flaticon-process" />
                                                                                </div>
                                                                            </center>
                                                                            <center>
                                                                                <Link to={`/file/detail/${v.Slug}`} className="ttm-btn btn-inline style2">Dataset({v.DatasetCount}) </Link>
                                                                            </center>
                                                                            <div className="featured-title text-center mt-2">
                                                                                <h5>{v.Name}</h5>
                                                                            </div>
                                                                            <div className="featured-desc">
                                                                                <p>{v.Description}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="featured-icon">
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                            )
                                                        })
                                                    }

                                                </>
                                                :
                                                <div className="col-md-12 text-center">
                                                    <img src={ILEmptyOrganisasi} className={'img-fluid'} width={400} /> <br />
                                                    <div className='mt-4'>
                                                        <span>File tidak ditemukan!</span>
                                                    </div>
                                                </div>
                                            : null
                                    }
                                </div>
                                {
                                    dataFiles ?
                                        dataFiles.length != 0 ?
                                            <div className="col-md-12">
                                                <div className="ttm-pagination">
                                                    <Pagination
                                                        activePage={activePage}
                                                        itemsCountPerPage={10}
                                                        totalItemsCount={totResultFiles}
                                                        pageRangeDisplayed={3}
                                                        onChange={handlePageChange}
                                                        linkClass={"page-numbers"}
                                                        activeLinkClass={"page-numbers current"}
                                                    />
                                                </div>
                                            </div>
                                            :
                                            null
                                        :
                                        <div className="row">
                                            <div className="col-md-3">
                                                <center>
                                                    <Skeleton height={70} width={70} />
                                                </center>
                                                <div className="mt-3 mb-3">
                                                    <Skeleton width={'60%'} /><br />
                                                    <Skeleton />
                                                    <Skeleton />
                                                    <Skeleton />
                                                    <Skeleton />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <center>
                                                    <Skeleton height={70} width={70} />
                                                </center>
                                                <div className="mt-3 mb-3">
                                                    <Skeleton width={'60%'} /><br />
                                                    <Skeleton />
                                                    <Skeleton />
                                                    <Skeleton />
                                                    <Skeleton />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <center>
                                                    <Skeleton height={70} width={70} />
                                                </center>
                                                <div className="mt-3 mb-3">
                                                    <Skeleton width={'60%'} /><br />
                                                    <Skeleton />
                                                    <Skeleton />
                                                    <Skeleton />
                                                    <Skeleton />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <center>
                                                    <Skeleton height={70} width={70} />
                                                </center>
                                                <div className="mt-3 mb-3">
                                                    <Skeleton width={'60%'} /><br />
                                                    <Skeleton />
                                                    <Skeleton />
                                                    <Skeleton />
                                                    <Skeleton />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <center>
                                                    <Skeleton height={70} width={70} />
                                                </center>
                                                <div className="mt-3 mb-3">
                                                    <Skeleton width={'60%'} /><br />
                                                    <Skeleton />
                                                    <Skeleton />
                                                    <Skeleton />
                                                    <Skeleton />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <center>
                                                    <Skeleton height={70} width={70} />
                                                </center>
                                                <div className="mt-3 mb-3">
                                                    <Skeleton width={'60%'} /><br />
                                                    <Skeleton />
                                                    <Skeleton />
                                                    <Skeleton />
                                                    <Skeleton />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <center>
                                                    <Skeleton height={70} width={70} />
                                                </center>
                                                <div className="mt-3 mb-3">
                                                    <Skeleton width={'60%'} /><br />
                                                    <Skeleton />
                                                    <Skeleton />
                                                    <Skeleton />
                                                    <Skeleton />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <center>
                                                    <Skeleton height={70} width={70} />
                                                </center>
                                                <div className="mt-3 mb-3">
                                                    <Skeleton width={'60%'} /><br />
                                                    <Skeleton />
                                                    <Skeleton />
                                                    <Skeleton />
                                                    <Skeleton />
                                                </div>
                                            </div>


                                        </div>
                                }

                            </div>
                        </section>


                    </div>
                </section>

            </div>
        </>
    )
}

export default File;